import axios from "axios";

const api = axios.create({
    baseURL: '/api/v0/',
    withCredentials: true,
});

export function jobberAccountName(state: string|null) {
    return api.get("/jobber/account_name", {
        headers: {
            'X-INTEGRATION-STATE': state
        }
    });
}

export function jobberAuthorize(code: string|null, state: string|null) {
    return api.post("/jobber/authorize", {}, {
        headers: {
            'X-JOBBER-CODE': code,
            'X-INTEGRATION-STATE': state,
        }
    });
}

export function saveAngiAccountNumber(accountNumber: number, state: string|null) {
    return api.post("/angi/account_number", {
        account_number: accountNumber,
    }, {
        headers: {
            'X-INTEGRATION-STATE': state
        }
    })
}

export function sendAngiSampleRequest(state: string|null) {
    return api.post("/angi/sample_request", {}, {
        headers: {
            'X-INTEGRATION-STATE': state
        }
    })
}

export function getJobberMarketplaceUrl(state: string|null) {
    return api.get("/jobber/marketplace_url", {
        headers: {
            'X-INTEGRATION-STATE': state
        }
    })
}

export default api;
